import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`;

export const ImportModal = styled.div`
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  overflow: auto;
  animation-name: ${fadeIn};
  animation-duration: 0.3s;
  margin-bottom: 200px;
`;

const popUp = keyframes`
    from { opacity: 0; transform: translateY(100px) }
    to { opacity: 1;  transform: translateY(0px) }
`;

export const ImportModalContent = styled.div`
  text-align: center;
  background-color: #fefefe;
  margin: 100px auto;
  padding: 20px;
  border: 1px solid #888;
  max-width: 600px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  animation-name: ${popUp};
  animation-duration: 0.3s;
  animation-delay: 0.1s;
  animation-fill-mode: both;

  h3 {
    margin: 0 0 10px 0;
    color: #001f48;
    font-size: 24px;
  }

  .template-info {
    margin: 0 0 20px 0;
    color: #666;
    font-size: 16px;
  }

  .file-upload-area {
    margin: 20px 0;

    .drop-zone {
      border: 2px dashed #ccc;
      border-radius: 8px;
      padding: 40px 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      background-color: #fafafa;
      min-height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.drag-over {
        border-color: #001f48;
        background-color: #f0f8ff;
      }

      &.has-file {
        border-color: #28a745;
        background-color: #f8fff8;
      }

      .upload-prompt {
        text-align: center;

        .upload-icon {
          font-size: 48px;
          margin-bottom: 10px;
        }

        .upload-text {
          p {
            margin: 5px 0;
            color: #666;
          }

          .browse-button {
            background: none;
            border: none;
            color: #001f48;
            text-decoration: underline;
            cursor: pointer;
            font-size: inherit;
          }
        }
      }

      .file-info {
        display: flex;
        align-items: center;
        width: 100%;

        .file-icon {
          font-size: 32px;
          margin-right: 15px;
        }

        .file-details {
          flex: 1;
          text-align: left;

          .file-name {
            font-weight: bold;
            color: #001f48;
            display: block;
            margin-bottom: 5px;
          }

          .file-size {
            color: #666;
            font-size: 14px;
          }
        }

        .remove-file {
          background: #dc3545;
          color: white;
          border: none;
          border-radius: 50%;
          width: 24px;
          height: 24px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          margin-left: 10px;

          &:hover {
            background: #c82333;
          }
        }
      }
    }
  }

  .requirements {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 15px;
    margin: 20px 0;
    text-align: left;

    h4 {
      margin: 0 0 10px 0;
      color: #001f48;
      font-size: 16px;
    }

    ul {
      margin: 0;
      padding-left: 20px;

      li {
        margin: 5px 0;
        color: #666;
        font-size: 14px;

        strong {
          color: #001f48;
        }
      }
    }
  }

  .error-message {
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 8px;
    padding: 10px 15px;
    margin: 15px 0;
    display: flex;
    align-items: center;
    color: #721c24;

    .error-icon {
      margin-right: 10px;
      font-size: 16px;
    }
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
`;
